import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { AccountService } from "src/app/services/account.service";
import { toastrService } from "src/app/services/ux/toastr.service";

@Component({
  selector: "verify-account",
  templateUrl: "./verify-account.component.html",
  styleUrls: ["./verify-account.component.css"]
})

export class VerifyAccount implements OnInit {
  shortUuid: string
  loading: boolean = false

  constructor(private accountService: AccountService, 
    public toastr: toastrService,
    private translateService: TranslateService) {

  }

  ngOnInit() {
    this.getShortUuid();
  }

  async getShortUuid() {
    this.loading = true
    try {
      const response: any = await this.accountService.GetShortUuid();

      this.shortUuid = response.uuid;
    } catch (err) {
      //@TODO: shfaq error message
    }
    this.loading = false
  }

  async checkVerified() {
    this.loading = true
    try {
      const res: any = await this.accountService.checkProfileIsVerified()
      if (res.authorized) this.toastr.success(this.translateService.instant("VerifyComponent.YourProfileHasBeenSuccessfullyAuthorized"));
      else this.toastr.warning(this.translateService.instant("VerifyComponent.YourProfileIsNotAuthorized"));
    } catch (error) {
      this.toastr.warning(error.data);
    }
    this.loading = false
  }
}